import api from 'services/api';
import { enforce, runSchema } from 'validation';

import { auditTrailSchema, type AuditTrail } from 'api/shared/auditTrail';

/**
 * GET `/zones/audit_trail/:name` — the zone's change history (newest first),
 * served by the backend's shared audit-trail helper (see api/shared/auditTrail).
 * Throws on transport error or structural validation failure; an entry whose
 * identity `audit_trail_id` drifted is dropped.
 */
export const getZoneAuditTrail = async (name: string): Promise<AuditTrail> => {
  const res = await api.get(`/zones/audit_trail/${encodeURIComponent(name)}`);
  const r = runSchema(auditTrailSchema, res.data, 'getZoneAuditTrail');
  if (!r.ok) {
    throw new Error('getZoneAuditTrail: response failed validation');
  }
  return enforce(r.value, r.warnings, ['audit_trail[*].audit_trail_id']);
};
